/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import { Button } from "primereact/button";
import { FilterValues } from "./GenerateReport";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { showError } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";

interface FilterProps {
  setFilterValues: any;
  filterValues: FilterValues;
}

const Filter = ({ setFilterValues, filterValues }: FilterProps) => {
  const [dates, setDates] = useState<Nullable<(Date | null)[]>>(null);
  const [dma, setDma] = useState<any>([]);
  const [location, setLocation] = useState<any>([]);
  const [area, setArea] = useState<any>([]);
  const [today, setToday] = useState<boolean>(false);
  const [screenSize, setScreenSize] = useState<number>(0);

  const toast = useRef<Toast>(null);

  const fetchDmaLocationArea = async () => {
    try {
      const response = await axios.get("admin/report-filter");
      setDma(response.data.DMA);
      setLocation(response.data.Location);
      setArea(response.data.Area);
    } catch (error: any) {
      showError(error.response.data.Message, toast);
    }
  };

  useEffect(() => {
    fetchDmaLocationArea();

    const handleResize = () => setScreenSize(window.innerWidth);
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const Datetoday = new Date();
    const formattedToday = Datetoday.toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'
    setDates([Datetoday, Datetoday]); // Set both start and end dates to today
    setFilterValues((prev: FilterValues) => ({
      ...prev,
      startDate: formattedToday,
      endDate: formattedToday,
    }));
  }, [today]);

  const formatFilterDate = (date: Date | null): string | null => {
    if (!date) return null;
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    )
      .toISOString()
      .split("T")[0]; // Format as 'YYYY-MM-DD'
  };

  const InvoiceDateConst = (date: (Date | null)[]): void => {
    setDates(date);

    const formattedStartDate = date[0] ? formatFilterDate(date[0]) : null;
    const formattedEndDate = date[1] ? formatFilterDate(date[1]) : null;
    setFilterValues((prev: FilterValues) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }));
  };

  const clearFilters = () => {
    setToday(!today);
    setFilterValues((prev: FilterValues) => ({
      ...prev,
      dma: null,
      location: null,
      area: null,
    }));
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="tw-px-2">
        <div
          className={`tw-transition-all tw-duration-300 tw-ease-in-out "tw-max-h-[700px] tw-opacity-100`}
        >
          <div
            className={`tw-flex ${
              screenSize < 1413 && screenSize > 1235 && "tw-flex-col"
            } tw-ml-[4px] tw-mb-1`}
          >
            <Button
              label="today"
              className={`${
                screenSize < 1541 && screenSize > 1235 ? "tw-ml-0" : "tw-ml-0"
              } ${
                screenSize < 1413 && screenSize > 1235 && "tw-w-11 tw-ml-[-1px]"
              } tw-text-blue-700 focus:tw-shadow-none`}
              severity="secondary"
              onClick={() => setToday(!today)}
              link
            />
            <h4
              className={`${
                screenSize < 1413 && screenSize > 1235 && "tw-w-31 tw-ml-[-1px]"
              } tw-text-purple-900 tw-ml-14`}
            >
              Select start and end date
            </h4>
          </div>
          <div className="tw-flex tw-flex-col custom-lg:tw-flex-row tw-gap-4">
            <div
              className="tw-mb-2"
              onClick={(e) => e.stopPropagation()} // Prevents the menu from closing
            >
              <Calendar
                className="tw-px-[14px] tw-py-[5px] tw-bg-gray-100 tw-border tw-border-solid tw-border-gray-400 tw-rounded-md tw-h-9 placeholder:tw-font-normal"
                dateFormat="dd-mm-yy"
                selectionMode="range"
                value={dates}
                maxDate={new Date()}
                onChange={(e) => {
                  e.stopPropagation();
                  InvoiceDateConst(e.value as (Date | null)[]);
                }}
                showIcon
                readOnlyInput
                hourFormat="12"
                inputClassName={`tw-bg-transparent`}
                hideOnRangeSelection
              />
            </div>
            <Dropdown
              id="dma"
              options={dma}
              placeholder="Select DMA"
              className="custom-lg:tw-w-[220px] tw-bg-gray-100 tw-w-[300px] tw-h-[36px] tw-items-center tw-border-gray-400 tw-border-solid tw-rounded-md tw-border"
              // className:"                          tw-w-[340px] tw-border-gray-400 tw-border-solid tw-rounded-md tw-border tw-bg-gray-100"
              value={filterValues.dma}
              onChange={(e) =>
                setFilterValues((prev: FilterValues) => ({
                  ...prev,
                  dma: e.target.value,
                }))
              }
              showClear
              filter
            />
            <Dropdown
              id="location"
              options={location}
              placeholder="Select Location"
              className="custom-lg:tw-w-[220px] tw-bg-gray-100 tw-w-[300px] tw-h-[36px] tw-items-center tw-border-gray-400 tw-border-solid tw-rounded-md tw-border"
              value={filterValues.location}
              onChange={(e) =>
                setFilterValues((prev: FilterValues) => ({
                  ...prev,
                  location: e.target.value,
                }))
              }
              showClear
              filter
            />
            <Dropdown
              id="area"
              options={area}
              placeholder="Select Area"
              className="custom-lg:tw-w-[220px] tw-bg-gray-100 tw-w-[300px] tw-h-[36px] tw-items-center tw-border-gray-400 tw-border-solid tw-rounded-md tw-border"
              value={filterValues.area}
              onChange={(e) =>
                setFilterValues((prev: FilterValues) => ({
                  ...prev,
                  area: e.target.value,
                }))
              }
              showClear
              radioGroup=""
              filter
            />
            <div className="tw-mt-[1px] custom-lg:tw-ml-[-10px] tw-ml-[219px]">
              <Button
                label="Clear"
                className="p-button-primary tw-text-white tw-bg-red-500 tw-p-1 tw-pr-3 tw-pl-3 tw-ml-4 tw-mr-[-10px] tw-mb-2 hover:tw-bg-[#d44343]"
                severity="success"
                onClick={clearFilters}
              ></Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Filter;
